import layoutReducer from "./layoutReducer";

export const layoutReducers = {
  layout: layoutReducer,
};
